import { useQuery } from '@tanstack/react-query';

import { getFeatureTasks } from '../client';
import { useSimulationId } from './useSimulationId';

export function useFeature(featureId: string) {
  const simId = useSimulationId();

  return useQuery({
    queryKey: ['feature', simId, featureId],
    queryFn: () =>
      getFeatureTasks({ path: { sim_id: simId, feature_id: featureId }, throwOnError: true }).then(({ data }) => data),
    refetchInterval: 30_000,
  });
}
